import clsx from 'clsx';

type SkeletonLoaderProps = {
  dataTestId?: string;
  className?: string;
};

export function SkeletonLoader({ dataTestId, className }: SkeletonLoaderProps) {
  return (
    <div
      className={clsx('animate-pulse rounded bg-slate-200', className)}
      datatest-id={dataTestId}
    />
  );
}
